import React, { useMemo } from 'react';
import { GetTradingBlockDomain } from '../../utilities/site';
export const ContactEmail = ({ accountNumber, siteGroup, className, }) => {
    const contactEmail = useMemo(() => `service@${GetTradingBlockDomain(accountNumber, siteGroup).toLocaleLowerCase()}`, [
        accountNumber,
        siteGroup,
    ]);
    return (React.createElement("a", { href: `mailto:${contactEmail}`, className: className }, contactEmail));
};
//# sourceMappingURL=ContactEmail.js.map